// extracted by mini-css-extract-plugin
export default {"form":"ModalEditAddress_form__JVlwb","map":"ModalEditAddress_map__eWjXj"};